import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 30);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
            <NavLink to="/" className="title" onClick={() => setMenuOpen(false)}>
                <h2>KrisCars4 Ltd</h2>
            </NavLink>

            <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <ul className={menuOpen ? "open" : ""}>
                <li><NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink></li>
                <li><NavLink to="/about" onClick={() => setMenuOpen(false)}>About Us</NavLink></li>
                <li><NavLink to="/services" onClick={() => setMenuOpen(false)}>Services</NavLink></li>
                <li><NavLink to="/parts" onClick={() => setMenuOpen(false)}>Parts</NavLink></li>
                <li><NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</NavLink></li>
            </ul>
        </header>
    );
}

export default Navbar;